module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="team-builder-info-container">\n	<div class="round-score info-item">\n		<h5 class="team-info-title">Round '+
((__t=( history_round_id || actual_round_id ))==null?'':_.escape(__t))+
' Score</h5>\n		<span class="team-info-value">\n			'+
((__t=( _.result(scoreflow, history_round_id, team_score) || '-' ))==null?'':_.escape(__t))+
'\n		</span>\n	</div>\n	<div class="info-item">\n		<h5 class="team-info-title">Overall Score</h5>\n		<span class="team-info-value">'+
((__t=( overall_points ))==null?'':_.escape(__t))+
'</span>\n	</div>\n	<div class="info-item">\n		<h5 class="team-info-title">Overall Rank</h5>\n		<span class="team-info-value">'+
((__t=( rank ))==null?'':_.escape(__t))+
'';
 if (overall_rank) { 
__p+='/'+
((__t=( overall_rank ))==null?'':_.escape(__t))+
' ';
 } 
__p+='</span>\n	</div>\n</div>';
}
return __p;
};
